import { render, staticRenderFns } from "./NewsRoom.vue?vue&type=template&id=0cf87579&scoped=true&"
import script from "./NewsRoom.vue?vue&type=script&lang=js&"
export * from "./NewsRoom.vue?vue&type=script&lang=js&"
import style0 from "./NewsRoom.vue?vue&type=style&index=0&id=0cf87579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf87579",
  null
  
)

export default component.exports